export default "__VITE_ASSET__c4be0b54__"